module.exports = __webpack_public_path__ + "static/Elemental_Water-c010987e590938ab0165129096f89046.jpg";